import { m8API } from 'services/production/m8';
import { normalizeM8CalculationComponent } from 'services/production/utils/normalizeM8CalculationComponent';
import { Product } from 'types/state';

export const getProducts = async (): Promise<Product[]> => {
  const components = await m8API.admin.getCalculationComponents();

  const products = components.map((component) =>
    normalizeM8CalculationComponent(component).toProduct()
  );

  return products;
};
